import React from 'react';
import ModalUI from "../ModalsUI/index";
import HeaderBillboards from '../HeadersUI/HeaderBillboards';
import VariantSwitchFooter from '../VariantSwitchUI/VariantSwitchFooter';
import VariantSwitchSideBar from "../VariantSwitchUI/VariantSwitchSideBar";

export default function VariantSwitchDisplay() {
    return (
        <React.Fragment>
            <HeaderBillboards />
            <VariantSwitchSideBar />
            <VariantSwitchFooter />
            <ModalUI />
        </React.Fragment>
    )
}